import { FunctionComponent, memo } from "react";
import classNames from "classnames";

import { IProps } from "./handle.types";
import "./handle.scss";

/**
 * Create slider handle
 * @param props.domain      Slider domain
 * @param props.disabled    Should the handle be disabled
 * @param props.format      Callback to format the handle value
 * @param props.handle      Handle for slider
 * @param props.getHandleProps
 */
const Handle: FunctionComponent<IProps> = ({
    children,
    domain,
    handle,
    disabled,
    getHandleProps,
    format = (tick) => tick,
}) => {
    const [min, max] = domain;
    const { id, value, percent } = handle;

    const lowerGripClassnames = classNames("metric-slider__handles__grip__lower", {
        "metric-slider__handles__grip__lower--disabled": disabled,
    });
    const showTooltip = true;
    return (
        <>
            {showTooltip && !disabled && (
                <div
                    style={{
                        left: `${percent}%`,
                        position: "absolute",
                    }}
                >
                    {typeof children !== "undefined" ? (
                        <>{children(value)}</>
                    ) : (
                        <div className="metric-slider__handles__tooltip">
                            <span className="metric-slider__handles__tooltip__text">{format(value)}</span>
                        </div>
                    )}
                </div>
            )}

            <div className="metric-slider__handles__grip">
                <div
                    className="metric-slider__handles__grip__upper"
                    style={{
                        left: `${percent}%`,
                    }}
                    {...getHandleProps(id, {
                        onMouseEnter: () => {},
                        onMouseLeave: () => {},
                    })}
                />
                <div
                    className={lowerGripClassnames}
                    role="slider"
                    aria-valuemin={min}
                    aria-valuemax={max}
                    aria-valuenow={value}
                    style={{
                        left: `${percent}%`,
                    }}
                />
            </div>
        </>
    );
};

export default memo(Handle);
